import { CpsButton, type CpsButtonProps } from "corpus";

export type ButtonProps = CpsButtonProps;

export const Button = ({
  ref,
  ...props
}: ButtonProps & {
  ref?: React.Ref<HTMLButtonElement>;
}) => {
  return <CpsButton variant="default" color="secondary" ref={ref} {...props} />;
};

Button.displayName = "Button";
